// Batch 27 · Add-on 2 Step 2 — follow one background job until it ends ("done" | "failed"); onProgress(pct, message) on the
// way. Returns the last job row. One helper for the screens that start a job on the user's click (Run / Rescan, Summarise).
import api from "@/lib/api";

export async function waitForJob(jobId, { onProgress, intervalMs = 1500, timeoutMs = 30 * 60 * 1000, get } = {}) {
  const fetchJob = get || ((id) => api.get(`/jobs/${id}`, { _silent: true }).then((r) => r.data));
  const t0 = Date.now();
  for (;;) {
    let j = null;
    try { j = await fetchJob(jobId); } catch { j = null; }
    if (j && onProgress) onProgress(j.progress_pct || 0, j.message || "");
    if (j && (j.status === "done" || j.status === "failed")) return j;
    if (Date.now() - t0 > timeoutMs) return j || { status: "unknown" };
    await new Promise((res) => setTimeout(res, intervalMs));
  }
}
